// extracted by mini-css-extract-plugin
export default {"menu":"UserGuide_menu__vKQF-","menuExpanded":"UserGuide_menuExpanded__Oe-g3","menuButton":"UserGuide_menuButton__Wo7yu","tooltip":"UserGuide_tooltip__D7DFL"};